import { useCallback, useState } from 'react'

import { useIsomorphicLayoutEffect } from '@src/hooks/useIsomorphicLayoutEffect'

interface GetPxFromRem {
  (rem: number, withUnit?: true): string
  (rem: number, withUnit: false): number
}

// TODO: do this in context and add debouncing
const usePx = (): GetPxFromRem => {
  const [tenPX, setTenPX] = useState(1)

  useIsomorphicLayoutEffect(() => {
    function updateSize() {
      const tenPX = window.getComputedStyle(document.documentElement).fontSize
      setTenPX(parseFloat(tenPX))
    }
    window.addEventListener('resize', updateSize)
    updateSize()
    return () => {
      window.removeEventListener('resize', updateSize)
    }
  }, [])

  const getPxFromRem = useCallback(
    (rem: number, withUnit = true) => {
      const pxVal = tenPX * rem
      return withUnit ? `${pxVal}px` : pxVal
    },
    [tenPX],
  ) as GetPxFromRem

  return getPxFromRem
}

export default usePx
